// Shared markdown renderer for the Mithra skin. Internal links (/mithra/...) route
// through React Router; all links (internal and external) open in a new tab. Uses the
// same remark/rehype plugins the lessons were authored against (GFM tables + raw <br/> HTML).
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";
import { Link } from "react-router-dom";

const components = {
  a({ node, href, children, ...props }) {
    if (href && href.startsWith("/")) {
      return (
        <Link to={href} target="_blank" rel="noopener noreferrer" {...props}>
          {children}
        </Link>
      );
    }
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
        {children}
      </a>
    );
  },
  // Fenced code blocks with a language (```json, ```text, ...) get Prism highlighting,
  // matching the lesson pages. Inline code and untagged fences fall back to plain <code>.
  code({ node, inline, className, children, ...props }) {
    const match = /language-(\w+)/.exec(className || "");
    return !inline && match ? (
      <SyntaxHighlighter
        children={String(children).replace(/\n$/, "")}
        style={vscDarkPlus}
        language={match[1]}
        PreTag="div"
        {...props}
      />
    ) : (
      <code className={className} {...props}>
        {children}
      </code>
    );
  },
};

function MithraMarkdown({ children, className = "mi-prose" }) {
  return (
    <div className={className}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]} components={components}>
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}

export default MithraMarkdown;
